import {
  Box,
  Button,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { decodeToken, OperationType } from '../../../../utils/settings';
import { toast, ToastContainer } from 'react-toastify';
import {
  createBusinessProfilerAction,
  getAllBusinessRoleAction,
  getbusinessProfilerAction,
  patchbusinessProfilerAction,
} from '../../action';

function NetworkDetails() {
  const [open, setOpen] = useState(false);
  const [networkDetailsList, setNetworkDetailsList] = useState({});
  const [networkDetails, setNetworkDetails] = useState({});
  const [addedNetworks, setAddedNetworks] = useState([]);
  const [firmDetails, setFirmDetails] = useState({});
  const [networkTypeList, setNetworkTypeList] = useState([]);
  const [editing, setEditing] = useState(false);

  const getprofiler = async () => {
    const { data, error, message } = await getbusinessProfilerAction();

    if (!error) setNetworkDetailsList(data.network_details);
    else toast.error(message);
  };

  const getNetworkType = async () => {
    const { data, error, message } = await getAllBusinessRoleAction();

    if (!error) {
      if (editing) return setNetworkTypeList(data);

      const existingNetworks = networkDetailsList.network_list.map(
        (item) => item.type,
      );
      const availableNetworks = data.filter(
        (network) => !existingNetworks.includes(network),
      );

      setNetworkTypeList(availableNetworks);
    } else toast.error(message);
  };

  useEffect(() => {
    if (Object.keys(networkDetailsList).length > 0 && open) {
      getNetworkType();
    }
  }, [networkDetailsList, editing, open]);

  useEffect(() => {
    getprofiler();

    decodeToken().then(({ default_company_info }) => {
      setFirmDetails(default_company_info);
    });
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setNetworkDetails({});
    setAddedNetworks([]);
    setEditing(false);
  };

  const addNetwork = () => {
    if (!networkDetails.type) return toast.error('Please Select Network Type');
    if (!networkDetails.number)
      return toast.error('Please Enter Number of Network');

    const payload = {
      type: networkDetails.type,
      number: networkDetails.number,
    };

    setNetworkTypeList((prev) =>
      prev.filter((item) => item !== networkDetails.type),
    );

    setNetworkDetails({});
    setAddedNetworks([...addedNetworks, payload]);
    toast.success('Network Saved');
  };

  const onFinish = async () => {
    const payload = {
      network_details: {
        firm_id: firmDetails.company_id,
        network_list: addedNetworks,
      },
    };

    const { error, message } = await createBusinessProfilerAction(payload);

    if (!error) {
      toast.success(message);
      handleClose();
      getprofiler();
    } else {
      toast.error(message);
    }
  };

  const onEdit = (data) => {
    setEditing(true);
    setOpen(true);

    const payload = data;

    setNetworkDetails(payload);
  };

  const onEditFinish = async () => {
    if (!networkDetails.type) return toast.error('Please Select Network Type');
    if (!networkDetails.number)
      return toast.error('Please Enter Number of Network');
    
    const payload = {
      network_details: {
        firm_id: firmDetails.company_id,
        network_list: [
          {
            id: networkDetails.id,
            operation_type: OperationType['UPDATE'],
            type: networkDetails.type,
            number: networkDetails.number,
          },
        ],
      },
    };

    const { error, message } = await patchbusinessProfilerAction(payload);

    if (!error) {
      toast.success(message);
      handleClose();
      getprofiler();
    } else {
      toast.error(message);
    }
  };

  return (
    <div>
      <ToastContainer className='custom-toast-container' />
      <CardContent
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 25,
        }}
      >
        {Object.keys(networkDetailsList).length > 0 &&
          networkDetailsList?.network_list.map((vv) => {
            return (
              <Box
                sx={{
                  borderWidth: 2,
                  borderColor: '#F59C1E',
                  borderStyle: 'solid',
                  padding: 2,
                  borderRadius: 2,
                  position: 'relative',
                  marginBottom: 3,
                }}
              >
                <div
                  className='editCtr'
                  onClick={() => onEdit(vv)}
                >
                  <Tooltip title='Edit Details'>
                    <EditIcon color='primary' />
                  </Tooltip>
                </div>
                <div
                  className='row-center'
                  style={{
                    justifyContent: 'space-between',
                    marginBottom: 10,
                  }}
                >
                  <div className='row-center'>
                    <Typography
                      fontSize={15}
                      sx={{ marginRight: 1 }}
                    >
                      Number of {vv.type}
                    </Typography>
                    -
                    <Typography
                      fontSize={15}
                      fontWeight={'600'}
                      sx={{ marginLeft: 1 }}
                    >
                      {vv.number}
                    </Typography>
                  </div>
                </div>
              </Box>
            );
          })}
      </CardContent>

      <div
        className='row-center'
        style={{
          justifyContent: 'flex-end',
        }}
      >
        <div>
          <Button
            onClick={handleOpen}
            sx={{ width: 150 }}
            variant='contained'
          >
            Add Details
          </Button>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box
          sx={{
            backgroundColor: 'white',
            width: '70%',
            overflowY: 'scroll',
            maxHeight: '90vh',
            borderRadius: '10px',
            padding: '20px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <CardContent>
            <div className='title-Ctr'>
              <Typography
                variant='h5'
                fontWeight={'600'}
              >
                Add Network Details
              </Typography>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Firm Name
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Firm Name'
                  name='name'
                  value={firmDetails?.company_name}
                  disabled
                  fullWidth
                  margin='normal'
                />
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Select Network Type
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <FormControl
                  // disabled={isEditing || isAddingMember}
                  fullWidth
                  margin='normal'
                >
                  <InputLabel id='demo-simple-select-label-type'>
                    Select Network Type
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label-type'
                    id='demo-simple-select'
                    value={networkDetails?.type || ''}
                    label=' Select Network Type'
                    onChange={(e) => {
                      const value = e.target.value;
                      setNetworkDetails((prev) => ({
                        ...prev,
                        type: value,
                      }));
                    }}
                  >
                    {networkDetailsList?.network_list &&
                      networkTypeList.map((item) => (
                        <MenuItem value={item}>{item}</MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Enter Number
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Enter Number'
                  name='number'
                  value={networkDetails?.number || ''}
                  fullWidth
                  onChange={(e) => {
                    const value = e.target.value;
                    setNetworkDetails((prev) => ({
                      ...prev,
                      number: value,
                    }));
                  }}
                  margin='normal'
                />
              </div>
            </div>

            {editing ? (
              <div
                className='row-center'
                style={{
                  justifyContent: 'flex-end',
                }}
              >
                <div>
                  <Button
                    onClick={onEditFinish}
                    sx={{ marginTop: 2 }}
                    variant='contained'
                  >
                    Update Details
                  </Button>
                </div>
              </div>
            ) : (
              <div
                className='row-center'
                style={{
                  justifyContent: 'flex-end',
                }}
              >
                <div>
                  <Button
                    onClick={addNetwork}
                    sx={{ width: 150, marginTop: 2 }}
                    variant='outlined'
                  >
                    Save
                  </Button>
                </div>
              </div>
            )}
          </CardContent>

          {addedNetworks.length > 0 && (
            <CardContent>
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label='simple table'
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Network Type</TableCell>
                      <TableCell align='right'>Number</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {addedNetworks.map((row) => (
                      <TableRow
                        key={`${row.type}-${row.number}`}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell
                          component='th'
                          scope='row'
                        >
                          {row.type}
                        </TableCell>
                        <TableCell align='right'>{row.number}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div
                className='row-center'
                style={{
                  justifyContent: 'flex-end',
                }}
              >
                <div>
                  <Button
                    onClick={onFinish}
                    sx={{ marginTop: 2 }}
                    variant='contained'
                  >
                    Submit Details
                  </Button>
                </div>
              </div>
            </CardContent>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default NetworkDetails;
